<template>
  <div>
    <form @submit.prevent="submit()" class="form">

      <b-field label="公開先">
        <b-select
          v-model="form.environment_id"
          placeholder="選択してください"
          expanded
        >
          <option
            v-for="environment in environments"
            :key="environment.id"
            :value="environment.id"
          >{{environment.value}}</option>
        </b-select>
      </b-field>

      <button class="button is-primary" type="submit">更新する</button>
    </form>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  props: ['survey'],

  data() {
    return {
      form: {
        environment_id: this.survey.environment_id,
      },
      environments: [],
    }
  },

  created() {
    this.fetchEnvironments()
  },

  methods: {
    submit() {
      axios.patch('/api/app/surveys/' + this.survey.id, this.form).then(() => {
        this.$parent.close()
      })
    },

    fetchEnvironments() {
      axios.get('/api/app/environments').then(({ data }) => {
        this.environments = data
      })
    }
  }
}
</script>

<style scoped>
</style>
